import { ExperimentProvider as CarvanaExperimentProvider } from '@carvana/experiment';
import type React from 'react';
import { commonEnvironment } from '~/constants/environment';
import type { Experiments } from '~/contracts';
import { useExperimentsWithIdentifiers } from './hooks';

const settings = {
  apiTimeout: 500, // TODO Does this do anything?
  cacheMinutes: 15,
  environment: commonEnvironment,
  killSwitch: process.env.CVNA_APP_EXPERIMENT_KILL_SWITCH
};

export type OwnProps = React.PropsWithChildren<{
  experiments?: Partial<Experiments>;
}>;

function ExperimentProvider(props: OwnProps) {
  const experimentsWithIdentifiers = useExperimentsWithIdentifiers();

  return (
    <CarvanaExperimentProvider
      defaults={settings}
      onPageLoadExperiments={experimentsWithIdentifiers}
      preloadedExperiments={props.experiments}
    >
      {props.children}
    </CarvanaExperimentProvider>
  );
}

export default ExperimentProvider;
